import React from "react";
import { bool, func, string } from "prop-types";
import { makeStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import { Button, IconButton, TextField } from "@material-ui/core";
import brandTheme from "../../../brandTheme/Theme";
import CustomeTextField from "../CustomeTextField";
import CustomSelectNew from "components/UpdateUi/CustomeSelect";
import { toCamelCase } from "utils/Utils";
import { useNavigate } from "react-router-dom";
import SearchIcon from "@material-ui/icons/Search";
const useStyles = makeStyles(() => ({
  mainContainer: {
    marginBottom: "17px",
    borderBottom: `1px solid ${brandTheme.mainColor}`,
    paddingBottom: "1.5%",
    marginTop: "10px",
  },

  label: {
    fontSize: brandTheme.headerFontSize,
    fontWeight: 700,
    display: "flex",
    alignItems: "center",
    paddingLeft: "15px",
    fontFamily: brandTheme.font.poppins,
    lineHeight: "35px",
    color: brandTheme.mainColor,

    "@media (max-width: 960px)": {
      marginBottom: "10px",
    },

    "@media (max-width: 600px)": {
      justifyContent: "center",
      padding: "0px",
      marginBottom: "15px",
    },
  },

  spamText: {
    fontWeight: 700,
    lineHeight: "1.5rem",
    display: "flex",
    alignItems: "center",
    paddingLeft: "15px",
    fontFamily: brandTheme.font.poppins,
    textTransform: "capitalize",
  },

  searchContainer: {
  display: "flex",
  alignItems: "center",
  gap: "10px",
  fontFamily: brandTheme.font.poppins,

  "@media (max-width: 1400px)": {
    flexWrap: "wrap",
  },

  "& .MuiOutlinedInput-input": {
      padding: "10px",
    },
  "@media (max-width: 650px)": {
    flexDirection: "column",
    alignItems: "stretch",
    gap: "10px",
  },
},

  field: {
    "& .MuiInputBase-root": {
      height: "40px",
      fontSize: "13px",
      fontFamily: brandTheme.font.poppins,
    },

    "& .MuiOutlinedInput-input": {
      padding: "10px",
    },

    "& .MuiInputLabel-root": {
      fontFamily: brandTheme.font.poppins,
    },
  },

  dateField: {
  minWidth: "125px",
    width:'40%',
  "& .MuiInputBase-root": {
    height: "40px",
    fontSize: "12px",
    fontFamily: brandTheme.font.poppins,
  },

  "& .MuiOutlinedInput-input": {
    padding: "10px 8px !important",
  },

  "& .MuiInputLabel-root": {
    fontFamily: brandTheme.font.poppins,
    fontSize: "13px",
  },

  "@media (max-width: 1400px)": {
    width: "40%",
  },
},
searchButton: {
  height: "40px",
  // width: "40px",
  minWidth: "40px",
  padding: "10px",
  backgroundColor: brandTheme.mainColor,
  color: brandTheme.white,
  borderRadius: "7px",

  "&:hover": {
    backgroundColor: brandTheme.buttonHoverColor,
  },

  "&.Mui-disabled": {
    backgroundColor: brandTheme.shaddowColor,
    color: brandTheme.white,
  },
},

  buttonContainer: {
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",
    gap: "15px",
    fontFamily: brandTheme.font.poppins,
    paddingRight: "2%",

    "@media (max-width: 960px)": {
      marginTop: "10px",
    },

    "@media (max-width: 600px)": {
      justifyContent: "center",
      padding: "0px",
    },

    "& .MuiButton-root.Mui-disabled": {
      backgroundColor: brandTheme.shaddowColor,
      background: "inherit",
    },
  },

  button: {
    background:
      "linear-gradient(135deg, #15254F 0%, #1CB167 50%, #28D17F 100%)",
    color: brandTheme.white,
    borderRadius: "10px",
    padding: "10px 15px",
    minWidth: "140px",
    textTransform: "capitalize",

    "&:hover": {
      backgroundColor: brandTheme.buttonHoverColor,
    },
  },

  button2: {
    minWidth: "140px",
    textTransform: "capitalize",
    backgroundColor: brandTheme.button2Color,

    "&:hover": {
      backgroundColor: brandTheme.buttonHoverColor,
    },
  },

  fieldContaienr: {
    padding: "0 10px",

    "@media (max-width: 600px)": {
      padding: "0px",
    },
  },
  serachInputContainer:{
 '@media (min-width: 768px) and (max-width: 1400px)': {
    maxWidth:'88% !important',
    flexBasis:'88% !important',
    },
    '& .MuiInputLabel-formControl':{
      top:'-8px',
    }
  },
  dateFilterContainer:{
    '@media (min-width: 768px) and (max-width: 1400px)': {
    maxWidth:'88% !important',
    flexBasis:'88% !important',
    },
  }
}));

const SubHeader = ({
  label,
  button1,
  button2,
  disabled1,
  disabled2,
  button1click,
  button2click,

  // Existing search props
  searchLabel,
  search,
  searchValue,
  onSearchChange,

  // New date/search props
  dateFilter,
  fromDate,
  toDate,
  onFromDateChange,
  onToDateChange,
  onDateSearch,
  searchButtonLabel = "Search",
  disabledSearch,

  message,
  colorFlag,
  onlyLabel,
  selectInput,
  selectLabel,
  selectData,
  handleSelectChange,
  selectValue,
  noButton,
  cancelButtonUrl,
  button2Icon,
}) => {
  const classes = useStyles();
  const navigate = useNavigate();

  const button3click = () => {
    if (cancelButtonUrl) {
      navigate(cancelButtonUrl);
    } else {
      navigate("/Dashboard");
    }
  };

  return (
    <Grid item xs={12} className={classes.mainContainer}>
      <Grid container alignItems="center">
        {/* Header Label */}
        <Grid
          item
          xs={12}
          sm={dateFilter ? 3 : onlyLabel ? 12 : 4}
          md={dateFilter ? 3 : onlyLabel ? 12 : 4}
          className={classes.label}
        >
          {label && toCamelCase(label)}
        </Grid>

        {/* Message */}
        {message && (
          <Grid item xs={12} sm={8} md={8} className={classes.label}>
            <span
              className={classes.spamText}
              style={{
                color: colorFlag ? brandTheme.errorColor : brandTheme.green,
                fontSize: "14px",
                fontStyle: "italic",
              }}
            >
              {message}
            </span>
          </Grid>
        )}

        {/* Search + Date Filters */}
        {dateFilter && (
          <Grid item xs={12} sm={!button1 ? 9 : 7} md={!button1 ? 9 : 7} className={classes.searchContainer}>
            {/* Search Input */}
            <Grid item xs={12} sm={10} md={5} className={classes.serachInputContainer}>
            <CustomeTextField
              label={searchLabel || "Search"}
              value={searchValue || ""}
              onChange={(e) => onSearchChange(e.target.value)}
              search={true}
              style={{
                margin: "0px",
                flex: 1,
                minWidth: "130px",
              }}
              fullWidth={true}
            />
            </Grid>
            <Grid item xs={12} sm={12} md={7} style={{ display: "flex", alignItems: "center", gap: "15px" }} className={classes.dateFilterContainer}>
            <TextField
              className={`${classes.field} ${classes.dateField}`}
              label="From date"
              type="date"
              value={fromDate || ""}
              onChange={(e) => onFromDateChange(e.target.value)}
              variant="outlined"
              InputLabelProps={{
                shrink: true,
              }}
            />
            <TextField
              className={`${classes.field} ${classes.dateField}`}
              label="To date"
              type="date"
              value={toDate || ""}
              onChange={(e) => onToDateChange(e.target.value)}
              variant="outlined"
              InputLabelProps={{
                shrink: true,
              }}
            />
            <Button
              className={classes.searchButton}
              disabled={disabledSearch}
              onClick={onDateSearch}
            >
              {/* <SearchIcon /> */}
              Search
            </Button>
          </Grid>
          </Grid>
        )}

        {/* Existing Search Only */}
        {!dateFilter && search && (
          <Grid
            item
            xs={12}
            sm={message ? 8 : 3}
            md={message ? 8 : 3}
            className={classes.label}
          >
            <CustomeTextField
              label={searchLabel}
              value={searchValue}
              onChange={(e) => onSearchChange(e.target.value)}
              search={search}
              style={{ margin: "0px" }}
            />
          </Grid>
        )}

        {/* Select */}
        {selectInput && (
          <Grid item xs={12} sm={12} md={3} className={classes.fieldContaienr}>
            <CustomSelectNew
              label={selectLabel}
              id={selectLabel}
              value={selectValue}
              setState={handleSelectChange}
              data={selectData}
              type="type"
            />
          </Grid>
        )}

        {/* Main Buttons */}
        {(button1 || button2) && (
          <Grid item xs={12} sm={2} md={2} className={classes.buttonContainer}>
            {!noButton && (
              <Button
                className={`${classes.button2} ${classes.button}`}
                disabled={disabled2}
                onClick={button3click}
                id="button"
              >
                Cancel
              </Button>
            )}

            {button1 && (
              <Button
                className={classes.button}
                disabled={disabled1}
                onClick={button1click}
                id="button"
              >
                {button1}
              </Button>
            )}

            {button2 && (
              <Button
                className={`${classes.button2} ${classes.button}`}
                disabled={disabled2}
                onClick={button2click}
                id="button"
                startIcon={button2Icon}
              >
                {button2}
              </Button>
            )}
          </Grid>
        )}
      </Grid>
    </Grid>
  );
};

SubHeader.propTypes = {
  label: string,
  button1: string,
  button2: string,
  disabled1: bool,
  disabled2: bool,
  button1click: func,
  button2click: func,

  searchLabel: string,
  search: bool,
  searchValue: string,
  onSearchChange: func,

  dateFilter: bool,
  fromDate: string,
  toDate: string,
  onFromDateChange: func,
  onToDateChange: func,
  onDateSearch: func,
  searchButtonLabel: string,
  disabledSearch: bool,
};

export default SubHeader;
